import React from 'react';
import { useLazyGetCreditPrivateDataFromApiQuery } from '../../services/creditCards';
import BaseDecryptCreditCardPopover from './BaseDecryptCreditCardPopover';

export default function AdminDecryptCreditCardPopover({ creditCardId }) {
  return (
    <BaseDecryptCreditCardPopover
      creditCardId={creditCardId}
      useQueryHook={useLazyGetCreditPrivateDataFromApiQuery}
      tooltipText="View admin details for selected Credit Card"
    />
  );
}
